import React from 'react';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../constants/colors';

export const BilledAnnually: FC<{ isVisible: boolean; currency: string; price: number }> = ({
  isVisible,
  currency,
  price,
}) => {
  return (
    <StyledBilledAnnually isVisible={isVisible}>
      {`Billed annually as ${currency}${Math.ceil(price)}`}
    </StyledBilledAnnually>
  );
};

const StyledBilledAnnually = styled.div<{ isVisible: boolean }>`
  font-size: 16px;
  color: ${colors.lightGrey5};
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  height: 32px;
  max-height: 32px;
  transition: max-height 0.2s, opacity 0.2s, transform 0.2s;
  
  ${({ isVisible }) => !isVisible && css`
    max-height: 0;
    opacity: 0;
    transform: perspective(100px) translateY(8px);
  `};
`;
